module.exports = __webpack_public_path__ + "static/media/settings.6502d3df.svg";